import { format, parse } from 'date-fns';
import {
    findTimeZone,
    getZonedTime,
    getUnixTime,
    convertDateToTime,
    getUTCOffset
} from 'timezone-support';

const timezone = findTimeZone('America/New_York');

export function formatDateWithTime(str: string): string {
    if (!str) {
        return '';
    }
    return format(str, 'YYYY-MM-DD (HH:mm)');
}

export function formatDate(str: Date | string): string {
    if (!str) {
        return '';
    }
    return format(str, 'YYYY-MM-DD');
}

export function parseDate(str: string): Date {
    if (!str) {
        return null;
    }
    return parse(str);
}

export function nowEDT(): Date {
    const t = getZonedTime(new Date(), timezone);
    const nd = new Date(
        t.year,
        t.month - 1,
        t.day,
        t.hours,
        t.minutes,
        t.seconds
    );
    return nd;
}
